import { useTranslation } from 'react-i18next'
import React from 'react'

import { compactString } from '../../../utils/helpers/string'
import PlaceLevelPickerModal from './PlaceLevelPickerModal'
import SelectableLink from '../../../components/actions/SelectableLink'

const PlaceLevelPicker = ({ type, value, label, icon, ...props }) => {
  const { t } = useTranslation()
  const [open, setOpen] = React.useState(false)

  return (
    <>
      <SelectableLink
        icon={icon || 'BsFillTagsFill'}
        label={label || 'Nivel de Locais'}
        value={compactString(value, { t: t, tField: 'placeLevelIds' })}
        onClick={() => setOpen(true)}
        type={type}
      />
      <PlaceLevelPickerModal open={open} onClose={setOpen} value={value} {...props} />
    </>
  )
}

export default PlaceLevelPicker
